import type {
  CashList,
  ICashListConfigurationContext,
} from './CashListConfigurationContext';

export type CashListManualFlag =
  | 'manualAdjustment'
  | 'manualTransferOutgoing'
  | 'manualTransferIncoming'
  | 'manualDepositPayin'
  | 'manualDepositOther'
  | 'manualWithdrawalOther'
  | 'manualReceiptLinking';

export type CashListConfigIdKey =
  | 'payoutTargetCashListId'
  | 'payinTargetCashListId'
  | 'serviceProviderPaymentTargetCashListId'
  | 'pliantReferenceCashListId'
  | 'nursingHomeCashCashListId'
  | 'pliantCashCashListId';

export interface CashListSelectorRules {
  requireFlags?: CashListManualFlag[];
  excludeConfigIds?: CashListConfigIdKey[];
  onlyConfigIds?: CashListConfigIdKey[];
}

type ConfigIdSource = Pick<ICashListConfigurationContext, CashListConfigIdKey>;

const resolveConfigIds = (
  source: ConfigIdSource,
  keys: CashListConfigIdKey[] | undefined
): Set<string> => {
  const ids = new Set<string>();
  if (!keys) {
    return ids;
  }
  for (const key of keys) {
    const id = source[key];
    if (id) {
      ids.add(id);
    }
  }
  return ids;
};

export const filterCashListsForSelector = (
  cashLists: CashList[],
  configuration: ConfigIdSource,
  rules: CashListSelectorRules
): CashList[] => {
  const excludeIds = resolveConfigIds(configuration, rules.excludeConfigIds);
  const onlyIds = rules.onlyConfigIds
    ? resolveConfigIds(configuration, rules.onlyConfigIds)
    : undefined;

  return cashLists.filter((cashList) => {
    if (rules.requireFlags) {
      for (const flag of rules.requireFlags) {
        if (!cashList[flag]) {
          return false;
        }
      }
    }
    if (excludeIds.has(cashList.id)) {
      return false;
    }
    if (onlyIds && !onlyIds.has(cashList.id)) {
      return false;
    }
    return true;
  });
};
